import { BrowserRouter, Routes, Route, } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css"

import Home from './pages/Home';
import Layout from './components/Layout';
import AboutUs from './pages/about-us/AboutUs';
import Contact from './pages/contact/Contact';
import Reviews from './pages/reviews/Reviews';
import ServiceDetails from './pages/services/ServiceDetails';

function App() {
  return (
   <BrowserRouter>
		<Routes>
			<Route  path="/" element={
        <Layout>
          <Home />
        </Layout>
        } 
      />
      <Route  path="/about-us" element={
        <Layout>
          <AboutUs />
        </Layout>
        } 
      />

    <Route  path="/reviews" element={
		<Layout>
			<Reviews />
		</Layout>
        } 
      />

	<Route  path="/services/:slug" element={
		<Layout>
			<ServiceDetails />
		</Layout>
        } 
      />

      <Route  path="/contact" element={
        <Layout>
          <Contact />
        </Layout>
        } 
      />

		</Routes>
   </BrowserRouter>
  );
}

export default App;
